<dv-dynamic-form
  formTitle="{{ 'Vehicle.Information' | translate | uppercase }}"
  [elements]="vehicleElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<hr class="form-divider" />
<dv-dynamic-form
  class="dynamic-form-background"
  formTitle="{{ 'Viatracks' | uppercase }}"
  [elements]="viaTracksElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
@if (isVehicleDeleted) {
  <div class="reactivate-btn">
    <dv-button color="danger" (click)="onReactivateClick()">{{
      'Department.Reactivate' | translate | uppercase
    }}</dv-button>
  </div>
}
@if (metaDataService.hasSkiDomain()) {
  <hr class="form-divider" />
  <dv-dynamic-form
    formTitle="{{ 'Vehicle.RouteNetworkMaintainer' | translate | uppercase }}"
    [elements]="skiDomainElements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
}
<dv-save-panel
  labelCancel=""
  labelSave="{{ 'General.Save' | translate }}"
  [disableSave]="!formGroup.dirty || !formGroup.valid || saveInProgress()"
  (save)="onSave()">
  @if (createdTime) {
    <span>
      {{ 'Vehicle.Created' | translate }}:
      {{ createdTime | date: 'dd/MM/yyyy' }}
    </span>
  }
</dv-save-panel>
